import moment from 'moment';
export class BoostPortalBirthdayHelper {
    /*
    @param birthDate - IsoString format
    */
    isMemberUnderage(birthDate) {
        const birthDateMoment = moment(birthDate);
        const userAge = moment().diff(birthDateMoment, 'years');
        return userAge < 18;
    }
    /*
    @param birthDate - IsoString format
    */
    memberMeetsMinimumAge(birthDate, centerMinimumAge) {
        let centerMinimumAgeDefault = 0;
        const birthDateMoment = moment(birthDate);
        if (!birthDateMoment.isValid()) {
            return false;
        }
        if (centerMinimumAge && centerMinimumAge > 0) {
            centerMinimumAgeDefault = centerMinimumAge;
        }
        const userAge = moment().startOf('day').diff(birthDateMoment, 'years');
        return userAge >= centerMinimumAgeDefault;
    }
    /*
    @param birthDate - IsoString format
    */
    memberMeetsShortTermMinimumAge(birthDate, centerShortTermMinimumAge) {
        let centerShortTermMinimumAgeDefault = 18;
        const birthDateMoment = moment(birthDate);
        if (!birthDateMoment.isValid()) {
            return false;
        }
        if (centerShortTermMinimumAge) {
            centerShortTermMinimumAgeDefault = centerShortTermMinimumAge;
        }
        const userAge = moment().startOf('day').diff(birthDateMoment, 'years');
        return userAge >= centerShortTermMinimumAgeDefault;
    }
}
